export const connectorKey = "connector";
export const welcomeScreenUnlockedKey = "welcomeScreenUnlocked";
export const dashboardWelcomeKey = "dashboardWelcome";
export const termsAccepted = "termsAccepted";
export const investTokens = "investTokens";
export const investPrices = "investPrices";
export const liquidityIsBeta = "liquidityIsBeta";
export const whitelistedKey = "whitelistEnabled";
// export const whitelistAccountKey = "whitelistAccount";
